<template>
  <a-modal
    :visible="visible"
    :mask-closable="false"
    :keyboard="false"
    :destroy-on-close="true"
    :ok-button-props="{ visible: false }"
    :width="700"
    centered
    @cancel="handleCancel"
  >
    <template #title>
      <div class="title">
        <span class="main"> Vista previa "{{ form.name }}" </span>
        <span class="amount">
          {{ activeInputs.length }} {{ activeInputs.length === 1 ? "pregunta" : "preguntas" }}
        </span>
      </div>
    </template>

    <CustomScrollbar class="scroll" height="calc(100vh - 300px)" auto>
      <DynamicInputs :form="form" :product="1" modal-key="" />
    </CustomScrollbar>

    <template #footer>
      <a-button key="back" @click="handleCancel">Cerrar vista previa</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ElementStatus, Form } from "@/@types/entities/forms";

import DynamicInputs from "@/app/workspace/components/form/DynamicInputs.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

const props = defineProps<{
  visible: boolean;
  form: Form;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
}>();

const activeInputs = computed(() =>
  props.form.form.filter((input) => input.status === ElementStatus.Active)
);

const handleCancel = () => emit("update:visible", false);
</script>

<style scoped lang="sass">
.title
  display: flex
  align-items: baseline
  gap: 8px

  .amount
    color: $gray-6
    font-style: italic
    font-size: 14px
    font-weight: 400

.scroll
  padding: 0 20px
</style>
